module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-11-1c9f976766c483ea685fe15ec0b1c68e.svg";